import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface ExteriorWallFinishProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const ExteriorWallFinish: React.FC<ExteriorWallFinishProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [exteriorWallFinish, set_exteriorWallFinish] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Exterior Finishes']?.['Exterior Wall Finish'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Exterior Finishes': { ...b.values?.['Exterior Finishes'], 'Exterior Wall Finish': v } } })
    );
    const label = 'Exterior Wall Finish';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(exteriorWallFinish)}
                />
            ) : (
                <MoneyBox
                    id={'exteriorWallFinish'}
                    allowNegative={false}
                    value={exteriorWallFinish}
                    onChange={(value) => set_exteriorWallFinish(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
